module.exports = __webpack_public_path__ + "img/1 (144).a8a8fba2.png";